/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import { getUserFirstName } from '@braindate/domain/lib/user/util';
import {
  getBraindateConversation,
  getBraindatePath,
} from '@braindate/domain/lib/braindate/util';

import styles from './CheckInTakeOverOnsiteAction.style';

import messages from 'src/shared/app/check-in/l10n/checkInTakeOverL10n';
import { isConversationAboutGroupBraindate } from 'src/shared/domain/conversation/util/conversationUtil';

import type { Braindate } from '@braindate/domain/lib/braindate/type';
import LinkButton from 'src/shared/ui/component/link/LinkButton';
import useSelf from 'src/shared/domain/user/hook/useSelf';
import { getBraindateOtherParticipant } from 'src/shared/domain/braindate/util/braindateUtil';
import CheckInActionButton from 'src/shared/app/check-in/component/notification/CheckInActionButton';

type Props = {
  braindate: Braindate,
  onClick?: () => void,
};

const useStyles = createUseThemeStyles(styles);

const CheckInTakeOverOnsiteAction = ({
  braindate,
  onClick,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const conversation = getBraindateConversation(braindate);
  const isGroupBraindate = isConversationAboutGroupBraindate(conversation);
  const selfUser = useSelf();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.button}>
        <LinkButton to={getBraindatePath(braindate)} onClick={onClick}>
          {isGroupBraindate
            ? intl.formatMessage(messages.chatWithGroup)
            : intl.formatMessage(messages.chatWith, {
                firstname:
                  selfUser &&
                  getUserFirstName(
                    getBraindateOtherParticipant(braindate, selfUser),
                  ),
              })}
        </LinkButton>
      </div>
      <div className={classes.button}>
        <CheckInActionButton
          braindate={braindate}
          onClick={onClick}
          showCheckin={false}
        />
      </div>
    </div>
  );
};

export default React.memo<Props>(CheckInTakeOverOnsiteAction);
